
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmAground as ObiAlarmAgroundElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-aground.js';
 
 
 

 
 export const ObiAlarmAground = createComponent({
   react: React,
   tagName: 'obi-alarm-aground',
   elementClass: ObiAlarmAgroundElement,
   events: {
     
   }
  });
 
 